import React from 'react';
import {
  Modal as RNModal,
  Pressable,
  StyleProp,
  StyleSheet,
  View,
  ViewStyle,
} from 'react-native';

interface ModalSheetProps {
  visible: boolean;
  onDismiss: () => void;
  cardStyle?: StyleProp<ViewStyle>;
  children: React.ReactNode;
}

// Uses RN Modal instead of Paper's Portal+Modal: Paper's Surface splits styles into outer/inner layers on iOS, breaking width caps and maxHeight on iPad.
const ModalSheet: React.FC<ModalSheetProps> = ({
  visible,
  onDismiss,
  cardStyle,
  children,
}) => {
  return (
    <RNModal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onDismiss}
      statusBarTranslucent
      hardwareAccelerated
    >
      <View style={styles.root}>
        {/* Backdrop is a sibling BEHIND the card, not its parent: a press on
            the card never bubbles here (so it can't dismiss), and — crucially —
            nothing claims the touch responder on touch-start, so an inner
            ScrollView keeps full control of the scroll gesture on device. */}
        <Pressable
          style={styles.backdrop}
          onPress={onDismiss}
          testID="modal-sheet-backdrop"
        />
        <View style={[styles.card, cardStyle]}>{children}</View>
      </View>
    </RNModal>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  backdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  card: {
    width: '90%',
    maxWidth: 600,
    maxHeight: '85%',
    overflow: 'hidden',
  },
});

export default ModalSheet;
